<div id="printArea" class="a5-page text-bold">
  <!-- Address Section -->
  <div class="card" *ngIf="billDetails?.billingType != 'SHOP'">

    <!-- To Address (Start Side) -->

    <!-- From Address (End Side) -->
    <div class="from-address ms-3" *ngIf="buyerType != 'RESELLER' && !billDetails?.shopAddress">
      <h2 class="mb-n1">From :</h2>
      <p class="mb-n1">Shree Thangam Textiles,</p>
      <p class="mb-n1">Budget bazaar,</p>
      <p class="mb-n1"> Maniram Mahal, Near Cine Priya Theater Side Gate,<br>
        Kuruvikaran 2nd Street, Annanagar,</p>
      <p class="mb-n1"> Madurai - 625020</p>
      <p class="mb-n1">Ph: 81100 07090</p>
    </div>

    <div class="from-address ms-3" *ngIf="buyerType != 'RESELLER' && billDetails?.shopAddress">
      <h2 class="mb-n1">From :</h2>
      <p class="mb-n1">{{this.billDetails?.shopAddress?.name}}</p>
      <p class="mb-n1">{{this.billDetails?.shopAddress?.address}},</p>
      <!-- <p class="mb-n1"> Maniram Mahal, Near Cine Priya Theater Side Gate,<br>
        Kuruvikaran 2nd Street, Annanagar,</p>
      <p class="mb-n1"> Madurai - 625020</p> -->
      <p class="mb-n1">Ph: {{this.billDetails?.shopAddress?.number}}</p>
    </div>

    <div class="from-address ms-3" *ngIf="this.buyerType == 'RESELLER'">
      <h2 class="mb-n1">From :</h2>
      <p class="mb-n1">{{ billDetails?.resellerName }}</p>
      <p class="mb-n1">{{ billDetails?.resellerPhone }}</p>
    </div>


    <!-- Separator -->
    <hr>

    <div class="to-address text-start ms-3" *ngIf="!billDetails?.userAddress || billDetails?.userAddress === 'null'">

      <h2 class="mb-n1">To :</h2>
      <p class="mb-n1" *ngIf="billDetails?.customerName">{{ billDetails.customerName }},</p>
      <p class="mb-n1" *ngIf="billDetails?.doorNo">{{ billDetails.doorNo }},</p>
      <p class="mb-n1" *ngIf="billDetails?.street">{{ billDetails.street }},</p>
      <p class="mb-n1" *ngIf="billDetails?.city">{{ billDetails.city }},</p>
      <p class="mb-n1" *ngIf="billDetails?.pincode">{{ billDetails.state }} - {{ billDetails.pincode }},</p>
      <p class="mb-n1" *ngIf="billDetails?.phoneNumber">Ph: {{ billDetails.phoneNumber }}</p>
      <p class="mb-n1 text-end me-3" *ngIf="billDetails?.invoiceNumber">
        Inv.No: {{ billDetails.invoiceNumber }}
      </p>
    </div>

    <div class="to-address text-start ms-3" *ngIf="billDetails?.userAddress && billDetails?.userAddress !== 'null'">

      <h2 class="mb-n1">To :</h2>
      <p class="mb-n1" *ngIf="billDetails?.customerName">{{ billDetails.customerName }},</p>

      <div class="mb-n1" style="white-space: pre-line;">
        {{ billDetails.userAddress }}
      </div>

      <p class="mb-n1">{{ billDetails.state }},</p>
      <p class="mb-n1" *ngIf="billDetails?.phoneNumber">Ph: {{ billDetails.phoneNumber }}</p>
      <p class="mb-n1 text-end me-3" *ngIf="billDetails?.invoiceNumber">
        Inv.No: {{ billDetails.invoiceNumber }}
      </p>
    </div>
  </div>


  <!-- Invoice Table -->
  <div class="disclaimer text-sm">
    <div class="row mt-2" *ngIf="this.buyerType == 'RESELLER'"></div>
    <div class="invoice-section mt-3">
      <table class="disclaimer">
        <thead>
          <tr *ngIf="!billDetails?.reSellerAddress">
            <th colspan="8" class="text-center">
              <div class="invoice-header">
                <h3 *ngIf="this.buyerType == 'RESELLER'" class="text-center">Bill Details</h3>
                <img *ngIf="buyerType == 'USER'" src="../../../assets/img/budget-logo.png" class="logo">
                <div class="company-info" *ngIf="buyerType == 'USER'">
                  <h2 class="company-name">Shree Thangam Textiles,</h2>
                  <p class="mb-n2 text-lg">Maniram Mahal,
                    Near Cine Priya Theater Side Gate,</p>
                  <p class="mb-n2 text-lg">Kuruvikaran 2nd Street,
                    Annanagar, Madurai - 625020</p>
                  <p class="mb-n2 text-lg">PH:+91 81100 07090 , GSTIN: 33EEUPS2192F1Z1</p>
                  <p class="mb-n2 text-lg"><i class="bi bi-youtube"></i>Joint Saree Collection</p>
                </div>
              </div>
            </th>
          </tr>

          <tr *ngIf="buyerType == 'USER' && billDetails?.billingType == 'SHOP'">
            <th colspan="8">
              <div class="d-flex align-items-start">
                <h2 class="text-bold me-3">Customer Details :</h2>
                <div class="d-flex flex-column"
                  *ngIf="!billDetails?.userAddress || billDetails?.userAddress === 'null'">

                  <span class="text-end">Inv.No : {{ billDetails?.invoiceNumber }}</span>

                  <span class="text-start" *ngIf="billDetails?.customerName">
                    {{ billDetails?.customerName }},
                  </span>

                  <span class="text-start" *ngIf="billDetails?.phoneNumber">
                    {{ billDetails?.phoneNumber }},
                  </span>

                  <span class="text-start">
                    {{ billDetails?.doorNo }}
                    <span *ngIf="billDetails?.doorNo">,</span>
                    {{ billDetails?.street }}
                    <span *ngIf="billDetails?.street">,</span>
                    {{ billDetails?.city }},
                  </span>

                  <span class="text-start">
                    {{ billDetails?.state }} - {{ billDetails?.pincode }}
                  </span>

                </div>

                <div class="d-flex flex-column" *ngIf="billDetails?.userAddress && billDetails?.userAddress !== 'null'">

                  <span class="text-end">Inv.No : {{ billDetails?.invoiceNumber }}</span>

                  <span class="text-start" *ngIf="billDetails?.customerName">
                    {{ billDetails?.customerName }},
                  </span>

                  <div class="text-start" style="white-space: pre-line;">
                    {{ billDetails?.userAddress }}
                  </div>

                  <span class="text-start">
                    {{ billDetails?.state }}
                  </span>

                </div>
              </div>
            </th>
          </tr>

          <tr class="text-sm">
            <th>S.No</th>
            <th>Product Name</th>
            <th>HSN Code</th>
            <th>Code</th>
            <th>Size</th>
            <th>Quantity</th>
            <th>Unit Price (Incl. GST)</th>
            <th>Taxable Value (₹)</th>
          </tr>
        </thead>
        <tbody class="text-sm">
          <tr *ngFor="let item of billDetails?.products; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item?.productName }}</td>
            <td>{{ item?.hsnCode || '-' }}</td>
            <td>{{ item?.productCode }}</td>
            <td>{{ item?.size }}</td>
            <td>{{ item?.quantity }}</td>
            <td>{{ item?.unitPrice }}</td>
            <td class="text-end">{{
              ((item?.quantity * item?.unitPrice) / 1.05)
              | currency:'INR'
              }}</td>
          </tr>
        </tbody>
        <!-- <tfoot class="text-sm">
          <tr>
            <td colspan="6" class="text-end pe-3"><strong>Total (In Rs)</strong></td>
            <td class="text-end"><strong>{{ (billDetails?.subTotal | currency:'INR') || "-"}}</strong></td>
          </tr>
          <tr *ngIf="billDetails?.billingType == 'ONLINE' && billDetails?.shippingAmount != null">
            <td colspan="6" class="text-end pe-3"><strong>Shipping Amount (In Rs)</strong></td>
            <td class="text-end"><strong>+ {{ (billDetails?.shippingAmount | currency:'INR') || "-"}}</strong></td>
          </tr>
          <tr *ngIf="billDetails?.discount > 0 || billDetails?.manualDiscountAmount > 0">
            <td colspan="6" class="text-end pe-3"><strong>Discount (In Rs)</strong></td>
            <td class="text-end"><strong>{{ ((billDetails?.discount + billDetails?.manualDiscountAmount)  |
                currency:'INR') || "-"}}</strong></td>
          </tr>
          <tr>
            <td colspan="6" class="text-end pe-3"><strong>Final Amount (In Rs)</strong></td>
            <td class="text-end"><strong>{{ (billDetails?.totalAmount.toFixed(2) | currency:'INR') || '-' }}</strong>
            </td>
          </tr>
        </tfoot> -->
        <tfoot class="text-sm">

          <!-- Taxable Value -->
          <tr>
            <td colspan="7" class="text-end">
              <strong>Taxable Value + Shipping Charge</strong>
            </td>
            <td class="text-end">
              {{ (billDetails?.withoutGst) | currency:'INR' }}
            </td>
          </tr>

          <!-- Shipping Charge -->
          <!-- <tr *ngIf="billDetails?.shippingAmount > 0">
            <td colspan="7" class="text-end">
              <strong>Shipping Charge</strong>
            </td>
            <td class="text-end">
              + {{ billDetails?.shippingAmount | currency:'INR' }}
            </td>
          </tr> -->

          <!-- CGST -->
          <tr *ngIf="billDetails?.igstValue == 0">
            <td colspan="7" class="text-end">
              <strong>CGST &#64; 2.5%</strong>
            </td>
            <td class="text-end">
              + {{ billDetails?.cgstValue | currency:'INR' }}
            </td>
          </tr>

          <!-- SGST -->
          <tr *ngIf="billDetails?.igstValue == 0">
            <td colspan="7" class="text-end">
              <strong>SGST &#64; 2.5%</strong>
            </td>
            <td class="text-end">
              + {{ billDetails?.sgstValue | currency:'INR' }}
            </td>
          </tr>

          <!-- IGST -->
          <tr *ngIf="billDetails?.igstValue > 0">
            <td colspan="7" class="text-end">
              <strong>IGST &#64; 5%</strong>
            </td>
            <td class="text-end">
              + {{ billDetails?.igstValue | currency:'INR' }}
            </td>
          </tr>

          <!-- Discount -->
          <tr *ngIf="(billDetails?.discount || 0) + (billDetails?.manualDiscountAmount || 0) > 0">
            <td colspan="7" class="text-end">
              <strong>Discount</strong>
            </td>
            <td class="text-end text-danger">
              - {{
              ((billDetails?.discount || 0) +
              (billDetails?.manualDiscountAmount || 0))
              | currency:'INR'
              }}
            </td>
          </tr>


          <!-- Grand Total -->
          <tr>
            <td colspan="7" class="text-end">
              <strong>Grand Total</strong>
            </td>

            <td class="text-end">
              <strong>
                {{ getGrandTotal(billDetails) | currency:'INR' }}
              </strong>
            </td>
          </tr>


          <!-- Amount Paid -->
          <tr *ngIf="(billDetails?.paidAmount || 0) > 0">
            <td colspan="7" class="text-end">
              <strong>Amount Paid</strong>
            </td>

            <td class="text-end text-success">
              <strong>
                {{ (billDetails?.paidAmount || 0) | currency:'INR' }}
              </strong>
            </td>
          </tr>


          <!-- Wallet Amount Used -->
          <!-- Show only when wallet was actually used -->
          <tr *ngIf="(billDetails?.walletDebitAmount || 0) > 0">
            <td colspan="7" class="text-end">
              <strong>Wallet Amount Used</strong>
            </td>

            <td class="text-end">
              <strong>
                {{ (billDetails?.walletDebitAmount || 0) | currency:'INR' }}
              </strong>
            </td>
          </tr>


          <!-- Customer Wallet Balance -->
          <!-- Example: Bill ₹500, Paid ₹800 = Wallet Balance ₹300 -->
          <tr *ngIf="
    billDetails?.walletBalance || 0
  ">
            <td colspan="7" class="text-end">
              <strong>Customer Wallet Balance</strong>
            </td>

            <td class="text-end text-success">
              <strong>
                {{
                (
                (billDetails?.walletBalance || 0)
                ) | currency:'INR'
                }}
              </strong>
            </td>
          </tr>


          <!-- Balance Due -->
          <!-- Example: Bill ₹500, Paid ₹400 = Due ₹100 -->
          <tr *ngIf="
    (billDetails?.paidAmount || 0) <
    getGrandTotal(billDetails)
  ">
            <td colspan="7" class="text-end">
              <strong>Balance Due</strong>
            </td>

            <td class="text-end text-danger">
              <strong>
                {{
                (
                getGrandTotal(billDetails) -
                ((billDetails?.paidAmount + billDetails?.walletDebitAmount) || 0)
                ) | currency:'INR'
                }}
              </strong>
            </td>
          </tr>

        </tfoot>
      </table>
    </div>

    <div style="border-top: 1px solid transparent; padding: 3px;">
      <h3 class="mt-3 text-end disclaimer">Amount in words:
        <span class="dotted-underline text-bold"> {{numberToWords(billDetails?.totalAmount)}} </span>
      </h3>
    </div>

    <div class="row end-font">
      <h4 class="text-bold ">Disclaimer:</h4>
      <!-- <p class="mb-n2">This bill reflects the details of the textile purchase made by the customer.All items are sold
        as-is
        and are subject to the terms and conditions of sale.No returns or exchanges are allowed unless specified by
        store policy.
        Please review your purchase carefully; discrepancies must be reported within 1 day from the date of purchase.
      </p> -->
      <p class="mb-n2">No Returns & Exchange</p>
    </div>
  </div>

</div>

<footer class="fixed-footer bg-light py-2 px-4">
  <div class="row align-items-center">
    <div class="col text-start ms-3">
      <!-- <h5 class="mb-0">***** <span class="text-bold">Exchange Within 7 Days Only</span> *****</h5> -->
    </div>
    <div class="col text-end me-3">
      <h5 class="mb-0 fw-bold">
        <span class="fs-6">For, </span>
        {{
        billDetails?.reSellerAddress?.name
        ? billDetails.reSellerAddress.name
        : 'Shree Thangam Textiles'
        }}
      </h5>
      <h5 class="mb-0 text-bold" *ngIf="billDetails?.reSellerAddress != null">
        For {{ billDetails?.reSellerAddress?.name }}
      </h5>
      <div class="mb-0 mt-1 text-blod">
        {{ getCurrentDate() }} - {{ getCurrentTime() }}
      </div>
    </div>
  </div>
</footer>